interface FeatureFlags {
  readonly isEventLogEnabled: boolean;
  readonly isDeadlineFilterEnabled: boolean;
  readonly isOptionalToolbarEnabled: boolean;
  readonly isNewOwnerPageEnabled: boolean;
  readonly isV2Enabled: boolean;
}

export const featureFlags: FeatureFlags = {
  isEventLogEnabled: true,
  isDeadlineFilterEnabled: false,
  isOptionalToolbarEnabled: true,
  isNewOwnerPageEnabled: true,
  isV2Enabled: true,
};
